import { GlobalStyles } from "@mui/material"

import { useAppLocalization } from "../../../modules/localization/components/AppLocalizationProvider"
import { getPrintFooterBoxStyles } from "../print/printMarginBoxes"

export function ContactInfoPrintFooter() {
    const { l10n } = useAppLocalization()
    const text = l10n.getString("meeting-service-contact-info-print-footer")

    return (
        <GlobalStyles
            styles={(theme) => ({
                "@page": {
                    marginBottom: "2rem",
                    "@bottom-center": {
                        ...getPrintFooterBoxStyles(theme),
                        content: JSON.stringify(text),
                    },
                },
            })}
        />
    )
}
